var React = require('react');

function DoNotEnter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M56,288V224a16,16,0,0,1,16-16H424a16,16,0,0,1,16,16v64a16,16,0,0,1-16,16H72A16,16,0,0,1,56,288Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM424,304H72a16,16,0,0,1-16-16V224a16,16,0,0,1,16-16H424a16,16,0,0,1,16,16v64A16,16,0,0,1,424,304Z","className":"fa-primary","key":2})]);
}

DoNotEnter.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = DoNotEnter;

DoNotEnter.default = DoNotEnter;
